function keepElementsAtEqualHeight( elementSelector ) {

	const elements = document && document.querySelectorAll( elementSelector );
	let isTicking = false;

	const resetElementHeight = () => {
		elements.forEach( element => element.style.minHeight = '' );
	};

	const findTallestHeight = () => {
		return [ ...elements ].reduce( ( accumulated, current ) => {
			const currHeight = current.getBoundingClientRect().height;

			return Math.max( accumulated, currHeight );
		}, 0 );
	};

	const setElementsToEqualHeight = () => {
		resetElementHeight();

		const tallestHeight = findTallestHeight();

		elements.forEach( element => {
			element.style.minHeight = `${ tallestHeight }px`;
		} );

		isTicking = false;
	};

	const requestTick = () => {
		if ( !isTicking && elements && elements.length > 0 ) {
			isTicking = true;
			requestAnimationFrame( setElementsToEqualHeight );
		}
	};

	if ( window ) {
		window.addEventListener( 'resize', requestTick );

		// Hack! Wait a bit to let layout render.
		setTimeout( requestTick, 100 );
	}
}

function addCardChoiceEventListners() {
	const buttons = document.querySelectorAll('.invoice-toggler');

	const onClick = (e) => {
		const waitForTransition = (callback) => {
			setTimeout(() => {
				callback();
			}, 200);
		};
		const button = e.currentTarget;
		const invoiceModels = button.parentNode.querySelector('.invoice-models');
		waitForTransition(() => {
			if (button.classList.contains('invoice-toggler--closed')) {
				invoiceModels.scrollIntoView(false);
			}
		});
	};
	buttons.forEach((button) => {
		button.addEventListener('click', onClick);
	});
}

function ProductCard() {
	return {
		keepElementsAtEqualHeight,
		addCardChoiceEventListners,
	}
}

export default ProductCard();
